import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  listSignupForm,
  postSignupForm,
  putSignupForm,
} from 'actions/signupForm'
import DataPanels from './DataPanels'
import Forms from './Forms'
import Sort from './Sort'
import { Grid, withStyles } from '@material-ui/core'
import Fab from './Fab'
import styles from './styles'
import language from 'utils/vast-languagepack'

export default connect(
  state => ({ loadStatus: state.loadStatus.forms }),
  dispatch =>
    bindActionCreators(
      { listSignupForm, postSignupForm, putSignupForm },
      dispatch
    )
)(
  withStyles(styles)(
    class FormsPage extends Component {
      componentDidMount() {
        if (!this.props.loadStatus) {
          this.props.listSignupForm()
        }
      }

      render() {
        return (
          <div style={{marginTop: '-24px'}} className={this.props.classes.page}>
            <Grid container justify='space-between'>
              <Grid item>
                <h1 style={{marginBlockStart: '0.67em', marginBlockEnd: '0.3em', marginLeft: '8px', color: '#014c94'}}>{language.signupform.add.header.form}</h1>
              </Grid>
              <Grid item style={{marginBlockStart: '0.67em', marginBlockEnd: '0.3em', marginRight: '8px'}}>
                <Fab history={this.props.history} />
              </Grid>
            </Grid>
            <Grid style={{ margin: 0, width: '100%' }} container spacing={16}>
              <Grid item xs={12}>
                <DataPanels />
              </Grid>
              <Grid item xs={12}>
                <Sort />
              </Grid>
              <Grid item xs={12}>
                <Forms />
              </Grid>
            </Grid>
          </div>
        );
      }
    }
  )
)
